import "./App.css";
import Navbar from "./components/navbar";
import Home from "./components/home";
import Footer from "./components/footer";
import Skills from "./components/skills";
import Projects from "./components/projects";
import Contact from "./components/contact";
import About from "./components/about";

function App() {
  return (
    <div>
      <Navbar />
      <main className="l-main">
        <Home />
        <About />
        <Skills />
        <Projects />
        <Contact />
      </main>
      <Footer />
      <div className="loader-container">
        <img src="pre.svg" alt="loader" />
      </div>
    </div>
  );
}

export default App;
